"use client";

import dynamic from "next/dynamic";
import RecentTrades from "./RecentTrades";

const KalshiRecentTrades = dynamic(() => import("./KalshiRecentTrades"), { ssr: false });
const HyperliquidRecentTrades = dynamic(() => import("./HyperliquidRecentTrades"), { ssr: false });

interface SourceAwareTradesProps {
  source: "polymarket" | "kalshi" | "predict" | "hyperliquid";
  marketSlug?: string;
  clobTokenIds?: string[];
  conditionId?: string | null;
  marketQuestion?: string;
  marketImage?: string | null;
  outcomes?: string[];
  isActive?: boolean;
  marketTicker?: string;
  predictMarketId?: string;
  hyperliquidSlug?: string;
  externalTrades?: any[] | null;
  hideHeader?: boolean;
}

export default function SourceAwareTrades({
  source,
  marketSlug,
  clobTokenIds,
  conditionId,
  marketQuestion,
  marketImage,
  outcomes,
  isActive,
  marketTicker,
  predictMarketId,
  hyperliquidSlug,
  externalTrades,
  hideHeader,
}: SourceAwareTradesProps) {
  if (source === "kalshi") {
    if (!marketTicker) return null;
    return <KalshiRecentTrades marketTicker={marketTicker} hideHeader={hideHeader} />;
  }

  if (source === "hyperliquid") {
    if (!hyperliquidSlug) return null;
    return <HyperliquidRecentTrades marketSlug={hyperliquidSlug} hideHeader={hideHeader} />;
  }

  if (!marketSlug && !predictMarketId) return null;
  return (
    <RecentTrades
      marketSlug={marketSlug || ""}
      clobTokenIds={clobTokenIds || []}
      conditionId={conditionId ?? null}
      marketQuestion={marketQuestion || ""}
      marketImage={marketImage}
      outcomes={outcomes || []}
      isActive={isActive}
      source={source}
      predictMarketId={predictMarketId}
      externalTrades={externalTrades}
      hideHeader={hideHeader}
      alwaysExpanded={hideHeader}
    />
  );
}
